import { gql, useQuery } from "@apollo/client";
import { get } from "lodash";

const CLIENT_STATE_QUERY = gql`
  query clientStateData {
    clientState @client
  }
`;

export default (key = "state", defaultValue = {}) => {
  const { data } = useQuery(CLIENT_STATE_QUERY);
  return get(data?.clientState, key, defaultValue);
};
